define('home/mixins/withThreadCardDefaultFooter',[
    'underscore',
    'home/mixins/withSubviews',
    'home/views/ThreadCardDefaultFooterView',
], function (
    _,
    withSubviews,
    ThreadCardDefaultFooterView
) {
    'use strict';

    /**
     * Default method for retrieving the thread off the model.
     * Expects the model to have a direct relation to the thread
     * (ex: activity, post), or be the thread itself.
     *
     * Can be overwritten by passing function to withThreadCardDefaultFooter
     * @returns {Thread}
     */
    var getThread = function () {
        return this.model.thread || this.model;
    };

    var withThreadCardDefaultFooter = {
        render: function (_render) {
            _render.call(this);
            this.footerRegion = this.addRegion('[data-role=footer]');
            this.activateRegion(this.footerRegion, this.createThreadDefaultFooter);
            return this;
        },

        createThreadDefaultFooter: function () {
            var thread = getThread.call(this);

            return new ThreadCardDefaultFooterView({
                el: this.footerRegion.el,
                model: thread,
                channel: this.channel,
            });
        },
    };

    return function () {
        withSubviews.call(this);

        this.createThreadDefaultFooter = withThreadCardDefaultFooter.createThreadDefaultFooter;
        this.render = _.wrap(this.render, withThreadCardDefaultFooter.render);
    };
});

